import { Button, Modal, ModalContent, ModalFooter } from 'components/lib';
import React from 'react';

interface Props {
  onCloseClick: () => void;
}

const AtlasRedirectedModal: React.FC<Props> = (props) => {
  return (
    <div id="atlas-redirected-modal">
      <Modal
        size="medium"
        onDismiss={props.onCloseClick}
        title="Atlas is now part of Bluebeam Cloud"
      >
        <ModalContent
          style={{
            fontSize: '16px',
            lineHeight: '22px',
            fontWeight: '400, Regular',
            color: '#373D42',
          }}
        >
          <p className="atlas-modal-first-paragraph">
            The Atlas map experience has been incorporated into Bluebeam Cloud.
            More information about Bluebeam Cloud and other exciting Bluebeam
            enhancements will be released mid-2022.
          </p>
          <p>
            In the meantime, we encourage you to{' '}
            <a
              style={{ color: '#3172c6', textDecoration: 'none' }}
              href="https://www.bluebeam.com/#newsletter-signup"
              target="_blank"
              rel="noreferrer"
            >
              sign up
            </a>{' '}
            for our newsletter so product updates can be delivered straight to
            your inbox.
          </p>
        </ModalContent>
        <ModalFooter footerStyle={{ borderTop: 'none' }}>
          <Button
            size="large"
            variant="tertiary"
            onClick={props.onCloseClick}
            id="atlas-modal-cancel-btn"
            style={{
              boxShadow: 'none',
              border: '1px solid #373D42',
              fontSize: '14px',
              minHeight: '32px',
              backgroundColor: '#ffff',
            }}
          >
            OK
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AtlasRedirectedModal;
